export const canonicalUrl = (host?: string, resolvedUrl?: string, locale?: string) => {
  if (!host) return process.env.NEXT_APP_WEB_HOST;
  if (!resolvedUrl) return `https://${host}`;

  let currentURL = `https://${host}${resolvedUrl}`;
  if (locale != 'en') {
    currentURL = `https://${host}/${locale}${resolvedUrl}`;
  }
  return currentURL.split('?')[0] || currentURL;
};

/**
 * 是否是开发环境
 */
export const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * 带 zy 前缀的 console.log 封装
 * 只在开发环境下打印，生产环境不打印
 */
export const zyLog = (...args: any[]) => {
  if (isDevelopment) {
    // eslint-disable-next-line no-console
    console.log(
      '%c🐙 [zy]',
      'color: #fff; background: linear-gradient(90deg, #667eea, #764ba2); padding: 2px 6px; border-radius: 4px; font-weight: bold;',
      ...args,
    );
  }
};
